import { Stack, Typography, Box, CardContent, Grid, Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions, Modal, DialogContentText } from "@mui/material";
import axios from "axios";
import React, { act, useEffect, useState, useRef } from "react";
import Axios from 'axios';
import CreateNewButton from "../commoncomponents/CreateNewButton";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import Divider from "@mui/material/Divider";
import { DefaultCard } from "../../assets/styled-components/card";
import { ErrorChips, SuccessChips, WarningChips } from "../../assets/styled-components/chips";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import CloseButton from "../commoncomponents/CloseButton";
import QueueIcon from "@mui/icons-material/Queue";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import EventBusy from "../../assets/images/event_busy.png";
import { DepartmentCard, StyledCard } from "../../assets/styled-components/StyledCard";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import SectionTitle from '../commoncomponents/SectionTitle';
import PageLoader from "../commoncomponents/PageLoader";
import commonMessages from "../../utility/constant";
import utilities from "../../utility/utilities";
import { useDispatch } from "react-redux";
import SignatureGrid from "../workordercomponents/SignatureGrid";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { useAccess } from "../../AccessContext";
import { updateOutsourceDetails, updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import Workreport from "../workordercomponents/Workreport";
import Unscheduleworkreport from "../workordercomponents/Unscheduleworkreport";
import SignatureVerifyEnduser from "./SignatureVerifyEnduser";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1250px",
  height: "100%",
  maxHeight: "calc(100% - 64px)",
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "5px",
  p: 4,
  overflowY: "auto",
  overflowX: "hidden",
};



const Userdash = ({ response }) => {
  const StyledCardTab = styled(Button)(({ theme }) => ({
    padding: "16px",
    flexDirection: "column",
    flex: 1,
    alignItems: "start",
    borderRadius: 0,
    gap: "4px",
    textTransform: "capitalize",
    "&.active": {
      backgroundColor: "#F6F2FA",
      "& .count": {
        color: theme.palette.primary.main,
      },
    },
    "&:hover": {
      "& .count": {
        color: theme.palette.primary.main,
      },
    },
  }));

  const location = useLocation();
  const printRef = useRef()
  const dispatch = useDispatch();
  const [activeTabheader, setActiveTabheader] = useState(location?.state?.activetabdeparment || 8);
  const [activeTab, setActiveTab] = useState(0);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const token = getAuthToken("id_token");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const navigate = useNavigate();
  const [gridApi, setGridApi] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const facilityid = getFacilityId("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false)
  const [open1, setOpen1] = useState(false); // verification-error dialog
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [reportdata, setReportdata] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0);
  const [scheduledCount, setScheduledCount] = useState(0);
  const [unscheduledCount, setUnscheduledCount] = useState(0);
  const [workrequestCount, setWorkrequestCount] = useState(0);
  const [pdmscheduledCount, setPdmscheduledCount] = useState(0);
  const [rischeduledCount, setRischeduledCount] = useState(0);
  const [verifiedCount, setVerifiedCount] = useState(0);
  const [data, setData] = useState([]);
  const [serviceType, setServiceType] = useState("");

  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];
  const [service, setService] = useState(serviceOptions[0]);
  const facilityId = localStorage.getItem('facilityId');
  const roleName = localStorage.getItem('roleName');
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGT001");
  const deptVendorAccess = (roleName === "Vendors" || roleName === "DeptUser") ? true : false;
  const [isAnyRowSelected, setIsAnyRowSelected] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  console.log(location, "============");
  const columns1 = [
    { field: "deptworkrequestno", headerName: "Work Request No.", width: 180 },
    {
      field: "workorderNo",
      headerName: "Work Order No.",
      width: 150
    },
    ...(roleName === "DeptUser"
      ? [
        {
          field: "departmentname",
          headerName: "Department Description",
          width: 150,
        },
      ]
      : []),
    {
      field: "deptWorkRequestDateFormate",
      headerName: "Work Request Date",
      width: 150,
      comparator: utils.dateComparator.bind(utils)
    },
    //  { field:"service" ,headerName:" Service "},
    { field: "type", headerName: "Work Request Type", width: 180 },
    {
      field: "status", headerName: "Status", width: 150,
      cellRenderer: (params) => {
        if (params.value === "Open" || params.value === "Cancelled") {
          return <ErrorChips label={params.value} />;

        } if (params.value === "Closed") {
          return <SuccessChips label={params.value} />;
        } else {

        }
      }
    },
    {
      field: "requestdetails",
      headerName: "Work Request Description",
      width: 150,
    },
  ];
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const isDeptUser = roleName === "DeptUser"; // Replace `userRole` with the actual variable that holds the user's role

  const allColumns = [
    ...(localStorage.getItem("roleName") === "DeptUser"
      ? [{
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: (params) => (params.data.status === "Completed" || params.data.status === "Completed-Outsource" || params.data.status === "Closed") && params.data.isverify === "",
        maxWidth: 80,
        width: 80,
        filter: false,
      }]
      : []),
    { field: "workorderno", headerName: "Work Order No.", width: 250, wrapHeaderText: false },
    {
      field: "status", headerName: "Status",
      cellRenderer: (params) => {
        if (params.value === "Closed") {
          return <SuccessChips label={params.value} />;
        }
        if (params.value === "In Progress" || params?.value === "In Progress-Outsource") {
          return <WarningChips label={params.value} />;
        } if (params.value === "Completed" || params.value === "Completed-Outsource") {
          return <SuccessChips label={params.value} />;
        } if (params.value === "Verified") {
          return <SuccessChips label={params.value} />;
        }
        else {
          return <ErrorChips label={params.value} />;
        }
      },
      width: 250,
    },
    {
      field: "respondedby", headerName: "Assignee", width: 250, wrapHeaderText: false
    },
    { field: "assetNo", headerName: "Asset No.", width: 250, wrapHeaderText: false },
    { field: "assetDesc", headerName: "Asset Description", width: 250, wrapHeaderText: false },
    {
      field: "departmentDesc", headerName: "Department", width: 250, wrapHeaderText: false
    },
    {
      field: "locationName", headerName: "Location", width: 250, wrapHeaderText: false
    },
    {
      field: "typecodedescription", headerName: "Type Code Description", width: 250, wrapHeaderText: false
    },
    { field: "targetDateFormates", headerName: "Work Order Date", width: 250, wrapHeaderText: false },
    ...(activeTab !== 2 
      ? [{ field: "schTargetDate", headerName: "Target Date", width: 250, wrapHeaderText: false }]
      : []),
    { field: "workgroup", headerName: "Work Group", width: 250, wrapHeaderText: false },
    { field: "workordertype", headerName: "W.O Type", width: 250, wrapHeaderText: false },
    { field: "requestDetails", headerName: "Request Details", width: 250, wrapHeaderText: false },
    { field: "service", headerName: "Service", width: 250, wrapHeaderText: false },
    { field: "resposeType", headerName: "Response Type", width: 250, wrapHeaderText: false },
    { field: "actiontaken", headerName: "Action Taken", width: 250, wrapHeaderText: false },
    { field: "completeddate", headerName: "Completion Date", width: 250, wrapHeaderText: false },
    ...(activeTab === 2
      ? [{
        field: "rating", headerName: "Rating", width: 250, wrapHeaderText: false,
        cellRenderer: (params) => {
          if (params.value == null) return "";
          const maxStars = 5; // Maximum number of stars

          const filledStars = Array.from({ length: params.value }, (_, i) => (
            <StarIcon key={`filled-${i}`} style={{ color: '#FFD700' }} />
          )); // Filled stars with gold color

          const emptyStars = Array.from(
            { length: maxStars - params.value },
            (_, i) => <StarBorderIcon key={`empty-${i}`} style={{ color: '#FFD700' }} />
          ); // Empty stars with gold color

          return [...filledStars, ...emptyStars]; // Combine filled and empty stars
        },
      }]
      : []),


  ];
  const columns = isDeptUser
    ? allColumns // Only include these columns for DeptUser
    : allColumns.filter(column => !["actiontaken", "completeddate"].includes(column.field)); // Exclude these columns for others

  const customColumns = {
    workorderno: "Work Order No.",
    targetDateFormates: "Work Order Date",
    status: "Status",
    maintenanceType: "Maintenance Type",
    workordertype: "W.O Type",
    respondedby: "Assignee",
    assetDesc: "Asset Description",
    assetNo: "Asset No.",
    departmentDesc: "Department",
    locationName: "Location",
    service: "Service",
    workgroup: "Work Group",
    requestDetails: "Request Details",
  }

  if (roleName === "DeptUser" && (activeTab == 0 || activeTab == 2 || activeTab === 9)) {
    columns.push({
      field: "respond",
      headerName: "Respond",
      cellRenderer: (params) => {
        // Show button only if maintenanceType is "Unscheduled"
        if (params.data.maintenanceType === "Unscheduled") {
          const isDisabled =
            (params.data.isresponse === "Yes") ||
            (params.data.isresponse === "" && params.data.respondedby == null);
          return (
            <Button
              variant="contained"
              sx={{ width: 30, height: 30 }}
              onClick={() => handleOpenModel(params.data)}
              disabled={isDisabled} // Disable or enable based on the condition
            >
              Respond
            </Button>
          );
        } else {
          // Do not render anything for "In Schedule" or other types
          return null;
        }
      },
      width: 250,
    });
  }

  if (roleName === "DeptUser" && (activeTab == 0 || activeTab == 2 || activeTab == 1 || activeTab === 9)) {
    columns.push({
      field: "Verify",
      headerName: "Verify",

      cellRenderer: (params) => {
        //workordertype:"PDM"

        // Show button only if maintenanceType is "Unscheduled"
        if ((params.data.workordertype !== "PDM" || params.data.workordertype !== "Routine Inspection") && (params.data.maintenanceType === "Unscheduled" || params.data.maintenanceType === "Scheduled") && (params.data.status === "Completed-Outsource" || params.data.status === "Completed"  || params.data.status === "Closed" || params.data.status === "Verified")) {
          const isDisabled =
            (params.data.isverify === "Yes");
          return (
            <Button
              variant="contained"
              sx={{ width: 30, height: 30 }}
              onClick={() => handleOpenModelverify(params.data)}
              disabled={isDisabled} // Disable or enable based on the condition
            >
              Verify
            </Button>
          );
        } else {
          // Do not render anything for "In Schedule" or other types
          return null;
        }
      },
      width: 250,
    });
  }

  // Work Order Verification: show Completion Date, Respond, Verify right after Assignee (Asset No follows)
  if (activeTab === 9) {
    const moveFields = ["completeddate", "respond", "Verify"];
    const movedColumns = moveFields
      .map((field) => columns.find((column) => column.field === field))
      .filter(Boolean);
    const remainingColumns = columns.filter((column) => !moveFields.includes(column.field));
    const assigneeIndex = remainingColumns.findIndex((column) => column.field === "respondedby");
    remainingColumns.splice(assigneeIndex + 1, 0, ...movedColumns);
    columns.splice(0, columns.length, ...remainingColumns);
  }


  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const handleSave = async (rowData) => {
    try {
      const token = getAuthToken('id_token'); // Get auth token logic
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      let endpoint;
      if (selectedservice === "FEMS") {
        endpoint = `${FemsGraph}/api/Graphfemworkorder/Updatefemunschworkorderdatetime/${selectedworkorderid}`;
      } else {
        endpoint = `${BemsGraph}/api/Graphbemworkorder/Updatebemunschworkorderdatetime/${selectedworkorderid}`;
      }

      // Sending PUT request
      await axios({
        method: 'put',
        url: endpoint,
        headers: config.headers,
      });

      // After successful response, show the success dialog
      handleSuccessDialog();
    } catch (error) {
      //  console.error('Error in handling save:', error);
    }
  };

  const handleDialogClose = (e, reason, closeFunction) => {
    if (reason !== "backdropClick") {
      closeFunction();
    }
  };
  const [openModal, setOpenModal] = useState(false);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const [selectedRowData1, setSelectedRowData1] = useState(null);
  const [verifyDialog, setVerifyDialog] = useState(false);
  const [verifyDialog1, setVerifyDialog1] = useState(false);


  const [open, setOpen] = useState(false);
  const [selectedWorkOrderNo, setSelectedWorkOrderNo] = useState(null);
  const [selectedworkorderid, setSelectedworkorderid] = useState(null);
  const [selectedservice, setSelectedservice] = useState(null);
  const [signatureDialog, setSignatureDialog] = useState(false);
  const [signatureDialog1, setSignatureDialog1] = useState(false);



  const handleOpenModel = (rowData) => {

    setSelectedWorkOrderNo(rowData.workorderno);  // Ensure this matches the field name in rowData
    setSelectedworkorderid(rowData.id);
    setSelectedservice(rowData.service);

    setOpen(true);
  };
  const onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();

    // const selectedRowIds = selectedRows.map((row) => ({
    //     id: row.id,
    //     title: row.title,
    //     serviceName: row.service, 
    // }))
    setIsAnyRowSelected(selectedRows.length > 0);
    setSelectedRowIds(selectedRows);

  };

  const handleVerifyAll = async () => {
    if (selectedRowIds.length === 0) {
      console.warn("No rows selected for verification.");
      return; // Exit early, preventing unnecessary loading state
    }

    try {

      const modalResult = await handleOpenModelverified(selectedRowIds);


      if (!modalResult) {
        console.warn("Modal closed without verification.");

        return;
      }

    } catch (error) {
      // console.error("Error in handleVerifyAll:", error);
    }


  };
  const handleOpenModelverify = (rowData) => {
    const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
    const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
    dispatch({
      type: "SERVICE&CATEGORY_TYPE", payload: {
        assetType: serviceType,
        category: categoryType
      }
    });
    // setSelectedworkorderid(rowData.id);
    setSelectedRowData(rowData)
    setSignatureDialog(true);



  };
  const handleOpenModelverified = (rowData) => {

    const selectedData = rowData.map((item) => ({

      id: item?.id,
      serviceType: item?.service?.trim() === "FEMS" ? "fem" : "bem",
      categoryType: item?.maintenanceType?.trim() === "Scheduled" ? "Scheduled" : "Unscheduled"
    }));

    const payloadData = {
      assetType: selectedData[0]?.serviceType,
      category: selectedData[0]?.categoryType,
    };

    dispatch({
      type: "SERVICE&CATEGORY_TYPE",
      payload: payloadData
    });

    setSelectedRowData(rowData);
    setSignatureDialog1(true);

  };

  const confirmAuthorization = async () => {

    await handleVerifyAll(); // Perform verification first


  };

  const handleCloseModel = () => {
    setOpen(false);
    setOpenSuccessDialog(false);
    fetchWorkOrders();
    fetchtotalCount();
  };

  const handleCloseWithoutFetch = () => {
    setOpen(false);
    setOpenSuccessDialog(false);
  };

  const handleSuccessDialog = () => {
    setOpenSuccessDialog(true); // Open success dialog
  };





  const allMonths = commonMessages.months; // Assuming `commonMessages.months` is an array of month names.
  const all = { label: "All", value: "All", id: "0" };
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  const [year, setYear] = useState(() => {
    const initialYear = location?.state?.year || currentYear.toString();
    return { label: initialYear, value: initialYear };
  });

  const [month, setMonth] = useState(() => {
    const initialMonth =
      location?.state?.month ||
      allMonths[currentMonthIndex]; // Default to current month if not in location.state
    return initialMonth;
  });

  const [monthsOptions, setMonthsOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);

  const fetchMaintenanceYears = async () => {
    try {
      const maintenanceYearResponse = await axios.get(
        `${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityid}?page=1&size=100`
      );
      const years = maintenanceYearResponse.data.items.map(year => ({
        label: year.maintyearvalue.toString(),
        value: year.maintyearvalue.toString(),
      }));
      setYearsOptions(years || []);
    } catch (error) {
      console.error('Error fetching maintenance years:', error);
    }
  };

  useEffect(() => {
    const selectedYear = parseInt(year.value);
    const isNextYear = currentMonthIndex === 11;

    const months =
      selectedYear === currentYear
        ? [
          all,
          ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
          ...(isNextYear ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
        ]
        : [all, ...allMonths]; // All months for previous years

    setMonthsOptions(months);

    if (!location?.state?.month) {
      setMonth(
        selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]
      );
    }
  }, [year, location?.state?.month]);

  const handleYearChange = (newValue) => {
    if (newValue && newValue.value !== year?.value) {
      const selectedYear = parseInt(newValue.value);
      const currentDate = new Date();
      const currentMonthIndex = currentDate.getMonth();

      const months =
        selectedYear === currentYear
          ? [
            all,
            ...allMonths.slice(0, currentMonthIndex + 1), // Up to the current month
            ...(currentMonthIndex === 11 ? [] : [allMonths[(currentMonthIndex + 1) % 12]]), // Include next month
          ]
          : [all, ...allMonths]; // All months for previous years

      setYear(newValue); // Keep the selected year
      setMonthsOptions(months);
      setMonth(selectedYear === currentYear ? allMonths[currentMonthIndex] : allMonths[0]); // Default to the start of the year for future years
    }
  };

  const handleMonthChange = (newValue) => {
    setMonth(newValue);
  };

  const handleTab = (index) => {
    if (activeTabheader === 8) {
      setActiveTab(index);
      // console.log(index, 'index');
      // console.log(activeTab, 'activeTab');
    }

  };

  const handleTabheader = (index) => {
    setActiveTabheader(index);
    handleRefresh();
    // console.log(index, 'index1');
    // console.log(activeTabheader, 'activeTab1');
  };


  useEffect(() => {


    if (year && month) {
      fetchData();
      fetchUserDepartments();
      fetchtotalCount();
      fetchWorkOrders();
      fetchMaintenanceYears();
    }
  }, [activeTab, year, month]);

  // const handleServiceChange = (newValue) => {
  //   setService(newValue);
  //   setPageIndex(1);
  //   setPageSize(10);
  //   setFilterModel([])
  //   setSortModel([]);

  //   // Set the current year and current month when service changes
  //   const currentYearValue = { label: currentYear.toString(), value: currentYear.toString() };
  //   const currentMonthIndex = new Date().getMonth();
  //   const currentMonthValue = allMonths[currentMonthIndex];

  //   setYear(currentYearValue);
  //   setMonthsOptions([...allMonths.slice(0, currentMonthIndex + 1)]); // Up to current month for the current year
  //   setMonth(currentMonthValue); // Set default to current month

  // };
  const fetchData = async () => {
    setIsLoading(true);
    setPageLoading(true);
    try {
      var departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      var userid = localStorage.getItem("UserId");

      // Fetch both FEMS and BEMS data in parallel
      const [femsResponse, bemsResponse] = await Promise.all([
        Axios.get(`${FemsGraph}/api/GraphfemDepartmentrequest/Gettotalcount/${facilityId}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`, config),
        Axios.get(`${BemsGraph}/api/GraphbemDepartmentrequest/Gettotalcount/${facilityId}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`, config)
      ]);

      // Extract the totalCount from both responses
      const femsCount = femsResponse.data.totalCount || 0;
      const bemsCount = bemsResponse.data.totalCount || 0;

      // Combine the counts
      const combinedCount = femsCount + bemsCount;

      // Set the combined count to state and log it
      setReportdata(combinedCount);

    } catch (error) {
      // console.error("Error fetching report data:", error);
    } finally {
      setIsLoading(false);
      setPageLoading(false);
    }
  };

  const fetchWorkOrders = async () => {
    //setRows([]);
    setFilteredRows([]);
    setIsLoading(true);
    setPageLoading(true);
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      const userid = localStorage.getItem("UserId");

      let responses = [];

      // Determine which API endpoints to call based on activeTab
      if (activeTab === 0) { // All Work Orders
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetCombinedWorkOrderSchedules/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetCombinedWorkOrderSchedules/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);
      } else if (activeTab === 1) { // Scheduled Work Orders
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);
      } else if (activeTab === 2) { // Unscheduled Work Orders
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderlistfemunSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderlistbemunSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);
      } else if (activeTab === 3) { // Department Requests
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/GraphfemDepartmentrequest/Getfemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/GraphbemDepartmentrequest/Getbemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);
      } else if (activeTab === 4) { // Department Requests
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemPDMSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemPDMSchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);

      } else if (activeTab === 5) { // Department Requests
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderfemRISchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderbemRISchedule/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);
      } else if (activeTab === 9) { // Work Order Count
        responses = await Promise.all([
          axios.get(
            `${FemsGraph}/api/Graphfemworkorder/GetverificationCombinedWorkOrderlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/Graphbemworkorder/GetverificationCombinedWorkOrderlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);
      }

      // Combine the data from all responses
      const allItems = responses
        .map((response) => response.data.items.map((data) => ({
          ...data,
          targetDateFormates: utilities.formatDate({ dateString: data?.targetDateFormate, format: "dd/mm/yy" })
        })) || [])
        .flat();

      // Filter or map data based on the active tab
      let formattedData = [];
      if (activeTab === 3) {
        // Filter the items where workorderNo is an empty string
        formattedData = allItems
          .filter((item) => item.workorderNo === "" && item.status === "Open")
          .map((item) => ({
            ...item,
            deptWorkRequestDateFormate: utilities.formatDate({ dateString: item?.deptWorkRequestDateFormate, format: "dd/mm/yy" })
          }));
      } else {
        // Use all items without filtering
        formattedData = allItems.map((item) => ({
          ...item,
          deptWorkRequestDateFormate: utilities.formatDate({ dateString: item?.deptWorkRequestDateFormate, format: "dd/mm/yy" })
        }));
      }

      setFilteredRows(formattedData.map((data) => ({
        ...data,
        enableDownload: data?.title === "Unscheduled" || data?.title === "Scheduled",
        isVerify: checkVerificationStatus(data?.isVerify)
      })));
    } catch (error) {
      //  console.error("Error fetching data", error);
    } finally {
      setIsLoading(false);
      setPageLoading(false);
    }
  };
  const checkVerificationStatus = (isVerify) => {
    return isVerify === "" ? "Pending" : isVerify;
  };


  const isRowSelectable = (rowNode) => ((rowNode.data.status === "Completed" || rowNode.data.status === "Completed-Outsource" || rowNode.data.status === "Closed") && rowNode.data.isverify === "");


  const fetchUserDepartments = async () => {
    setRows([]);
    setIsLoading(true);
    setPageLoading(true);

    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      const userid = localStorage.getItem("UserId");

      let combinedData = [];

      if (activeTabheader === 7) {
        // Fetch data for activeTab === 7
        const [femsResponse, bemsResponse] = await Promise.all([
          axios.get(
            `${FemsGraph}/api/GraphfemDepartmentrequest/Getfemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
          axios.get(
            `${BemsGraph}/api/GraphbemDepartmentrequest/Getbemsworkrequestlist/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`,
            config
          ),
        ]);

        // Combine data from both responses
        const femsData = femsResponse.data.items || [];
        const bemsData = bemsResponse.data.items || [];
        combinedData = [...femsData, ...bemsData];
      }

      // Format the combined data if needed
      const formattedData = combinedData.map((item) => ({
        ...item,
        // Add any additional formatting logic here if required
      }));

      // Update the state with formatted data
      setRows(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // Set loading states to false
      setIsLoading(false);
      setPageLoading(false);
    }
  };

  const handleDialogClose1 = (e, reason, closeFn) => {
    // keep your existing signature/behavior for backdrop click / esc handling
    if (closeFn) {
      closeFn();
    } else {
      setOpen1(false);
    }
  };

  const handleCloseModel1 = () => {
    setOpen1(false);
  };


  const handleClick = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      var userid = localStorage.getItem("UserId");
      // Define the API endpoints
      const apiUrlFEMS = `${FemsGraph}/api/Graphfemworkorder/GetUnscheduledVerificationWithin24HoursCount/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`;
      const apiUrlBEMS = `${BemsGraph}/api/Graphbemworkorder/GetUnscheduledVerificationWithin24HoursCount/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`;

      // Fetch data from both endpoints simultaneously
      const [responseFEMS, responseBEMS] = await Promise.all([
        axios.get(apiUrlFEMS, config),
        axios.get(apiUrlBEMS, config),
      ]);

      // Combine overdue counts from both responses (adjust if only one source matters)
      const femsOverdue = responseFEMS?.data?.overdueOrUnverifiedCount ?? 0;
      const bemsOverdue = responseBEMS?.data?.overdueOrUnverifiedCount ?? 0;
      const totalOverdue = femsOverdue + bemsOverdue;

      if (totalOverdue === 0) {
        navigate("/departmentworkrequest/register");
      } else {
        setOpen1(true);
      }
    } catch (error) {
      console.error("Error fetching work order counts:", error);
      // decide how you want failures handled — e.g. show the same dialog, or a separate error state
    }
  };



  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);

  };

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
  };

  const confirmDelete = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (!rowToDelete || !rowToDelete.id) {
        console.error("Row to delete or its id is undefined");
        return;
      }

      let response;

      if (rowToDelete.service === "FEMS") {
        response = await axios.delete(
          `${FemsGraph}/api/femdepartmentworkrequestheaders/${rowToDelete.id}`,
          config
        );
      } else if (rowToDelete.service === "BEMS") {
        response = await axios.delete(
          `${BemsGraph}/api/bemdepartmentworkrequestheaders/${rowToDelete.id}`,
          config
        );
      }

      if (response.status === 204) {
        setSuccessDialogOpen(true);
      }

      const updatedRows = rows.filter((row) => row.id !== rowToDelete.id);
      setRows(updatedRows);
    } catch (error) {
      console.error("Error deleting user department:", error); // Log the full error object
      if (error.response) {
        console.error("Error response data:", error.response.data); // Log the error response data
        console.error("Error response status:", error.response.status); // Log the error response status
      }
      if (error.response && error.response.status === 400) {
        setErrorMessage(
          "Record cannot be deleted as it is referred in another record."
        );
      } else {
        setErrorMessage(
          "An error occurred while deleting the Department Work Request. Please try again."
        );
      }
    } finally {
      setDeleteDialogOpen(false);
      setRowToDelete(null);
    }
  };

  const handleRefresh = () => {

    const currentYearValue = { label: currentYear.toString(), value: currentYear.toString() };
    const currentMonthIndex = new Date().getMonth();
    const currentMonthValue = allMonths[currentMonthIndex];

    setYear(currentYearValue);
    setMonthsOptions([...allMonths.slice(0, currentMonthIndex + 1)]); // Up to current month for the current year
    setMonth(currentMonthValue); // Set default to current month
  };




  const handleEdit = (rowData) => {
    navigate("/departmentworkrequest/register", {
      state: {
        ...rowData,
        isEditMode: true,
        assetno: { label: rowData.assetno, value: rowData.assetId },
        categoryId: { label: rowData.categoryName, value: rowData.categoryId },
        typeId: { label: rowData.type, value: rowData.typeId },
      },
    });
  };

  const handleView = (rowData) => {
    navigate("/departmentworkrequest/register", {
      state: {
        ...rowData,
        isViewMode: true,
        assetno: { label: rowData.assetno, value: rowData.assetId },
        categoryId: { label: rowData.categoryName, value: rowData.categoryId },
        typeId: { label: rowData.type, value: rowData.typeId },
      },
    });
  };
  const handleCreateUserDepartment = () => {
    navigate("/departmentworkrequest/register");
  };

  const [allCount, setAllCount] = useState(0);

  const fetchtotalCount = async () => {
    setIsLoading(true);
    setPageLoading(true);
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      var departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      var userid = localStorage.getItem("UserId");

      // Define the API endpoints
      const apiUrlFEMS = `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderCount/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`;
      const apiUrlBEMS = `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderCountsAsync/${facilityid}/${year?.value}/${month?.id}/${departmentid}/${userid}/${token}`;

      // Fetch data from both endpoints simultaneously
      const [responseFEMS, responseBEMS] = await Promise.all([
        axios.get(apiUrlFEMS, config),
        axios.get(apiUrlBEMS, config),
      ]);

      // Extract counts from both responses
      const femsCounts = responseFEMS.data || { totalCount: 0, scheduledCount: 0, unscheduledCount: 0, workrequestCount: 0, pdmscheduledCount: 0, rischeduledCount: 0, verifiedCount: 0 };
      const bemsCounts = responseBEMS.data || { totalCount: 0, scheduledCount: 0, unscheduledCount: 0, workrequestCount: 0, pdmscheduledCount: 0, rischeduledCount: 0, verifiedCount: 0 };

      // Combine counts from both services
      const totalCount = (localStorage.getItem("roleName") === "DeptUser"
        ? (femsCounts.departmentCount || 0) + (bemsCounts.departmentCount || 0)    // If "DeptUser", use departmentCount
        : (femsCounts.totalCount || 0) + (bemsCounts.totalCount || 0)  // Otherwise, sum femsCounts and bemsCounts
      );
      const scheduledCount = (femsCounts.scheduledCount || 0) + (bemsCounts.scheduledCount || 0);
      const unscheduledCount = (femsCounts.unscheduledCount || 0) + (bemsCounts.unscheduledCount || 0);
      const workrequestCount = (femsCounts.workrequestCount || 0) + (bemsCounts.workrequestCount || 0);
      const pdmscheduledCount = (femsCounts.pdmscheduledCount || 0) + (bemsCounts.pdmscheduledCount || 0);
      const rischeduledCount = (femsCounts.rischeduledCount || 0) + (bemsCounts.rischeduledCount || 0);
      const verifiedCount = (femsCounts.verifiedCount || 0) + (bemsCounts.verifiedCount || 0);
      // Update state with combined counts
      setAllCount(totalCount);
      setScheduledCount(scheduledCount);
      setUnscheduledCount(unscheduledCount);
      setWorkrequestCount(workrequestCount);
      setPdmscheduledCount(pdmscheduledCount);
      setRischeduledCount(rischeduledCount);
      setVerifiedCount(verifiedCount);


    } catch (error) {
      //  console.error("Error fetching data", error);
    } finally {
      setIsLoading(false);
      setPageLoading(false);
    }
  };



  const handleSignatureCloseDialog = () => {
    setSignatureDialog(false);
  };

  const handleSaveSignature = (id, data) => {
    setSignatureDialog(false);
    setVerifyDialog(true);
  };

  const handleConfirmRequestDialog = () => {
    setVerifyDialog(false);
    fetchWorkOrders();
    fetchtotalCount();

  };

  const handleCloseRequestDialog = () => {
    setVerifyDialog(false);
    fetchWorkOrders();
    fetchtotalCount();
  };

  // verify

  const handleSignatureCloseDialog1 = () => {
    setSignatureDialog1(false);
    setVerifyDialog1(false);
  };

  const handleSignatureCancelDialog1 = () => {
    setVerifyDialog1(true);
    setSignatureDialog1(false);
  };

  const handleSaveSignature1 = (id, data) => {
    setSignatureDialog1(false);
  };

  const handleConfirmRequestDialog1 = () => {
    setVerifyDialog1(false);
    fetchWorkOrders();
    fetchtotalCount();

  };

  const handleCloseRequestDialog1 = () => {
    setVerifyDialog1(false);
    fetchWorkOrders();
    fetchtotalCount();
  };

  const handleEditDepartment = (rowData) => {
    if (activeTab === 3) {
      navigate("/departmentworkrequest/register", {
        state: {
          ...rowData,
          year: year?.value,
          month: { value: month?.value, label: month?.label, id: month?.id },
          isChange: true,
          isEditMode: true,
          assetno: { label: rowData.assetno, value: rowData.assetId },
          categoryId: { label: rowData.categoryName, value: rowData.categoryId },
          typeId: { label: rowData.type, value: rowData.typeId },
        },
      });
    } else {
      const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
      const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
      dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
      dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
      dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
      dispatch({
        type: "SERVICE&CATEGORY_TYPE", payload: {
          assetType: serviceType,
          category: categoryType
        }
      });
      dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
      const title = `Edit ${rowData?.title || ""} Work Order`;
      // const title = `Edit ${rowData?.title} Work Order`;
      navigate("/workorder/register", {
        state: {
          ...rowData, service: serviceType, readOnly: false, editmode: true, category: categoryType, viewmode: false, title,
          year: year?.value,
          month: { value: month?.value, label: month?.label, id: month?.id },
          isChange: true,
        }
      });
    }
  };


  const handleViewDepartment = (rowData) => {
    if (activeTab === 3) {
      navigate("/departmentworkrequest/register", {
        state: {
          ...rowData,
          year: year?.value,
          month: { value: month?.value, label: month?.label, id: month?.id },
          isChange: true,
          isViewMode: true,
          assetno: { label: rowData.assetno, value: rowData.assetId },
          categoryId: { label: rowData.categoryName, value: rowData.categoryId },
          typeId: { label: rowData.type, value: rowData.typeId },
        },
      });
    } else {
      const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
      const categoryType = rowData?.maintenanceType === "Scheduled" ? "Scheduled" : "Unscheduled";
      dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
      dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
      dispatch({
        type: "SERVICE&CATEGORY_TYPE", payload: {
          category: categoryType
        }
      });
      dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.status, percentage: 0 }))
      const title = `View ${categoryType} Work Order`;
      navigate("/workorder/register", {
        state: {
          ...rowData, service: serviceType, readOnly: false, editmode: false, category: categoryType, viewmode: true, title,
          year: year?.value,
          month: { value: month?.value, label: month?.label, id: month?.id },
          isdepartmentViewMode: true,
          isChange: true,
        }
      });

    }
  };

  const handleDownload = async (rowData) => {
    setPageLoading(true);

    const servicetype = rowData?.service === "FEMS" ? "FEMS" : "BEMS";
    const checkCategory =
      rowData?.maintenanceType === "Unscheduled"
        ? "GetUnScheduleWorkorderFetchByWorkOrderId"
        : "GetScheduleWorkorderFetchByWorkOrderId";

    try {
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId("facilityid");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };


      const baseUrl = servicetype === "FEMS" ? FemsGraph : BemsGraph;
      const url = `${baseUrl}/api/GraphWorkorderReport/${checkCategory}/${facilityId},${rowData?.id},${token}`;


      const response = await axios.get(url, config);



      setData(response?.data);
      setServiceType(rowData?.service);
      setSelectedRowData(rowData);


      const modalComponent =
        rowData?.title === "Unscheduled"
          ? "Unscheduleworkreport"
          : "Workreport";

      setOpenReportModal(modalComponent);


      setTimeout(async () => {
        await downloadPDF(rowData);
      }, 4000);

    } catch (error) {
      console.error("Error downloading the report:", error);

    } finally {
      // setPageLoading(false);
    }
  };


  const downloadPDF = async (rowData) => {
    setPageLoading(true);
    const fileName = `${rowData?.title === 'Unscheduled' ? 'Unscheduled' : 'Scheduled'}_WORK_ORDER.pdf`;

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });


    const printElement = printRef.current;
    if (printElement) {
      const records = printElement.querySelectorAll('.record-paper');
      let pageNumber = 1;

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const addContentToPDF = (canvas, imgData) => {
        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;
        let yOffset = 0;

        while (yOffset < imgHeight) {
          if (pageNumber > 1) {
            pdf.addPage();
          }

          const sliceHeight = Math.min(pdfHeight, imgHeight - yOffset);
          pdf.addImage(
            imgData,
            'PNG',
            0,
            -yOffset,
            imgWidth,
            imgHeight,
            undefined,
            'FAST'
          );

          // Add footer
          pdf.setFontSize(8);


          pageNumber++;
          yOffset += pdfHeight;
        }
      };

      const processRecord = async (record, index) => {
        return html2canvas(record, {
          scale: 2,
          useCORS: true,
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            addContentToPDF(canvas, imgData);

            if (index === records.length - 1) {
              // pdf.save(fileName);
            }
          })
          .catch((error) => {
            console.error('Error generating PDF:', error);
          });
      };

      // Process all records and wait for all to complete
      await Promise.all(Array.from(records).map(processRecord));

      // Final PDF save with dynamic file name based on workordercategory
      pdf.save(fileName);
      setPageLoading(false); // Now, this will run only after all records are processed
      setOpenReportModal(false);

    }

  };


  return (


    <Box mt={{ xs: 2, md: 3 }} px={{ xs: 0, md: 5 }}>
      <PageLoader open={pageLoading} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <DepartmentCard
            className={activeTabheader === 7 ? "active" : ""}
            onClick={() => handleTabheader(7)}
          >
            <CardContent>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Box>
                  <Typography mb={1.5} variant="h5" color={"text.primary"}>
                    Total Work Request
                  </Typography>
                  <Typography m={0} variant="h1" color={"#435954"}>
                    {reportdata}
                  </Typography>
                </Box>
                <Box bgcolor={"#435954"} p={1} borderRadius={50}>
                  <Avatar
                    alt="Remy Sharp"
                    src={EventBusy}
                    sx={{ width: 50, height: 50 }}
                  />
                </Box>
              </Stack>
            </CardContent>
          </DepartmentCard>
        </Grid>



        <Grid item xs={12} sm={3}>
          <DepartmentCard
            className={activeTabheader === 8 ? "active" : ""}
            onClick={() => handleTabheader(8)}
          >
            <CardContent>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Box>
                  <Typography mb={1.5} variant="h5" color={"text.primary"}>
                    Work Order Management
                  </Typography>
                  <Typography m={0} variant="h1" color={"#435954"}>
                    {allCount}
                  </Typography>
                </Box>
                <Box bgcolor={"#435954"} p={1} borderRadius={50}>
                  <Avatar
                    alt="Remy Sharp"
                    src={EventBusy}
                    sx={{ width: 50, height: 50 }}
                  />
                </Box>
              </Stack>
            </CardContent>
          </DepartmentCard>
        </Grid>

        <Grid item xs={6} sm={6}>
          <DepartmentCard sx={{ cursor: "pointer", bgcolor: "primary.light" }}>
            <CardContent onClick={handleClick}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                mb={1}
              >
                <Box>
                  <Typography mb={1.5} variant="title1" color={"common.white"}>
                    Create New Work Request
                  </Typography>
                  <Typography m={0} variant="h1" color={"common.white"}></Typography>
                </Box>
                <Box p={1}>
                  <QueueIcon sx={{ fontSize: 40, color: "common.white" }} />
                </Box>
              </Stack>
            </CardContent>
          </DepartmentCard>
          <Typography  variant="title1">
            <span style={{ color: "red", fontWeight: 500, fontSize: "14px" }}>
              <span style={{  color: "#B7410E", fontWeight: 700, fontSize: "16px" }}>
                !
              </span>{" "}
              Note: Before raising a new work request, the user must verify all completed
              work orders. If not verified, a popup message will be displayed.
            </span>
          </Typography>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <DefaultCard>
        <Stack
          mb={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <SectionTitle title={activeTabheader === 7 ? `Department Work Request Total (${reportdata})` : `Work Order Management `} />

          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Year"}
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder={"Select Year"}
              disableClearable={true}
              highlight={true}
            />
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 160 }}
              label={"Month"}
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder={"Select Month"}
              disableClearable={true}
              disabled={!year}
              highlight={true}
            />
            {/* <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Service"}
              options={serviceOptions}
              value={service}
              onChange={handleServiceChange}
              placeholder={"Select Service"}
              highlight={true}
            /> */}
            {/* <CreateNewButton onClick={handleCreateUserDepartment} /> */}

            {activeTabheader === 7 ?
              <RefreshExportButtons
                exportFunction={() => { }}
                pagination={false}
                exportData={rows}
                refData={gridApi}
                handleRefresh={handleRefresh}
                title={`Department Work Request`}

              />
              :
              <RefreshExportButtons
                pagination={false}
                exportFunction={() => { }}
                exportData={filteredRows}
                refData={gridApi}
                customObj={customColumns}
                handleRefresh={handleRefresh}
                title={
                  activeTab === 3
                    ? `New Work Requests `
                    : activeTab === 0
                      ? `All Work Orders `
                      : activeTab === 1
                        ? `Scheduled Work Orders`
                        : activeTab === 2
                          ? `Unscheduled Work Orders `
                          : activeTab === 5
                            ? `Routine Inspection (RI) `
                            : activeTab === 9
                              ? `Work Order Verification`
                              : `Predictive Maintenance (PDM) `
                }
                enablePDF={false}
              />
            }
          </Stack>
        </Stack>
        {activeTabheader === 7 ? null :
          <DefaultCard>
            <Grid container spacing={2}>
              <Grid item xs={13} md={9}>
                <Stack
                  direction={"row"}
                  divider={<Divider orientation="vertical" flexItem />}
                  border={0.5}
                  borderColor={"divider"}
                  borderRadius={4}
                  overflow={"hidden"}
                  height={"100%"}
                >
                  <StyledCardTab
                    className={`${activeTab === 0 ? "active" : null}`}
                    onClick={() => handleTab(0)}

                  >
                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                      All Work Orders
                    </Typography>
                    <Typography
                      className="count"
                      color={"text.secondary"}
                      fontSize={24}
                      fontWeight={500}
                    >
                      {allCount}
                    </Typography>
                  </StyledCardTab>
                  <StyledCardTab
                    className={`${activeTab === 1 ? "active" : null}`}
                    onClick={() => handleTab(1)}
                  >
                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                      Scheduled Work Orders
                    </Typography>
                    <Typography
                      className="count"
                      color={"text.secondary"}
                      fontSize={24}
                      fontWeight={500}
                    >
                      {scheduledCount}
                    </Typography>
                  </StyledCardTab>
                  <StyledCardTab
                    className={`${activeTab === 2 ? "active" : null}`}
                    onClick={() => handleTab(2)}
                  >
                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                      Unscheduled Work Orders
                    </Typography>
                    <Typography
                      className="count"
                      color={"text.secondary"}
                      fontSize={24}
                      fontWeight={500}
                    >
                      {unscheduledCount}
                    </Typography>
                  </StyledCardTab>
                  <StyledCardTab
                    className={`${activeTab === 4 ? "active" : null}`}
                    onClick={() => handleTab(4)}
                  >
                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                      Predictive Maintenance (PDM)
                    </Typography>
                    <Typography
                      className="count"
                      color={"text.secondary"}
                      fontSize={24}
                      fontWeight={500}
                    >
                      {pdmscheduledCount}
                    </Typography>
                  </StyledCardTab>
                  <StyledCardTab
                    className={`${activeTab === 5 ? "active" : null}`}
                    onClick={() => handleTab(5)}
                  >
                    <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                      Routine Inspection  (RI)
                    </Typography>
                    <Typography
                      className="count"
                      color={"text.secondary"}
                      fontSize={24}
                      fontWeight={500}
                    >
                      {rischeduledCount}
                    </Typography>
                  </StyledCardTab>
                  {localStorage.getItem("roleName") !== "DeptUser" && (
                    <StyledCardTab
                      className={`${activeTab === 3 ? "active" : ""}`}
                      onClick={() => handleTab(3)}
                    >
                      <Typography color={"text.primary"} fontSize={13} fontWeight={900}>
                        New Work Requests
                      </Typography>
                      <Typography
                        className="count"
                        color={"text.secondary"}
                        fontSize={24}
                        fontWeight={500}
                      >
                        {0}
                      </Typography>
                    </StyledCardTab>
                  )}
                  <StyledCardTab
                    className={`${activeTab === 9 ? "active" : null}`}
                    onClick={() => handleTab(9)}
                  >
                    <Typography color={"red"} fontSize={13} fontWeight={900}>
                      Work Order Verification
                    </Typography>
                    <Typography
                      className="count"
                      color={"red"}
                      fontSize={24}
                      fontWeight={500}
                    >
                      {verifiedCount}
                    </Typography>
                  </StyledCardTab>
                </Stack>
              </Grid>
            </Grid>
          </DefaultCard>
        }
        <br></br>
        <br></br>

        {activeTabheader === 7 ?
          <CustomAgGrid
            rows={rows}
            columns={columns1}
            handleEdit={handleEdit && localStorage.getItem("roleName") !== "DeptUser"}
            handleDelete={handleDelete}
            handleView={handleView}
            ref={gridApi}
            setGridApi={setGridApi}
            isLoading={isLoading}
            pagination={true}

          />
          :
          <CustomAgGrid
            rows={filteredRows}
            columns={columns}
            handleEdit={localStorage.getItem("roleName") !== "DeptUser" && (access?.canEdit || deptVendorAccess) && handleEditDepartment}
            handleView={(access?.canView || deptVendorAccess) && handleViewDepartment}
            handleDownload={
              (activeTab === 0 || activeTab === 1 || activeTab === 2) && access?.canPrint
                ? (rowData) => handleDownload(rowData)
                : undefined
            }
            ref={gridApi}
            setGridApi={setGridApi}
            isPinnedRight={true}
            isLoading={isLoading}
            pagination={true}
            actionwidth={160}
            onSelectionChanged={onSelectionChanged}
            rowSelection="multiple"
            suppressRowClickSelection={true}
            isRowSelectable={isRowSelectable}
          />
        }
      </DefaultCard>

      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        content="Are you sure you want to delete?"
        cancelBtn="No"
        confirmBtn={"Yes"}
      />
      <CustomDialog
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
        content="Record deleted successfully."
        confirmBtn="Ok"
        onConfirm={handleSuccessDialogClose}
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        title="Warning!"
        content={errorMessage}
        cancelBtn="Cancel"
        confirmBtn={"Ok"}
      />


      <Dialog
        open={open1}
        onClose={(e, reason) => handleDialogClose1(e, reason, handleCloseModel1)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Verification Required</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please verify Completed Work order before Requesting new Work request
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModel1} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={(e, reason) => handleDialogClose(e, reason, handleCloseModel)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Respond Work Order</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to Respond this Work Order {selectedWorkOrderNo}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(rowData) => {
              handleSave(rowData); // Trigger save when clicking Yes
            }}
            color="primary"
            variant="contained"
          >
            YES
          </Button>
          <Button onClick={handleCloseWithoutFetch} color="primary" variant="outlined">
            NO
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Dialog */}
      <Dialog
        open={openSuccessDialog}
        onClose={(e, reason) => handleDialogClose(e, reason, handleCloseModel)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Success</DialogTitle>
        <DialogContent>
          <Typography variant="body1">The Work Order has been Responded Successfully.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModel} color="primary" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={signatureDialog} onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleSignatureCloseDialog();
        }
      }} >
        <DialogContent>
          <SignatureGrid
            onCancel={handleSignatureCloseDialog}
            onClear={handleSignatureCloseDialog}
            onSave={(data) => handleSaveSignature(data)}
            rowData={selectedRowData}
          // rowData={signatureRows.find((row) => row.id === selectedRowId)}
          />
        </DialogContent>
      </Dialog>
      <CustomAlert
        open={verifyDialog}
        onClose={handleCloseRequestDialog}
        onConfirm={handleConfirmRequestDialog}
        content={`${selectedRowData?.workorderno} Verified Successfully`}
        confirmBtn='OK'
      />

      <Dialog open={signatureDialog1} onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleSignatureCloseDialog1();
        }
      }} >
        <DialogContent>
          <SignatureVerifyEnduser
            onCancel={handleSignatureCloseDialog1}
            onClear={handleSignatureCloseDialog1}
            onSave={(data) => handleSaveSignature1(data)}
            rowData={selectedRowData}
            onClose={handleSignatureCancelDialog1}
          // rowData={signatureRows.find((row) => row.id === selectedRowId)}
          />
        </DialogContent>
      </Dialog>
      <CustomAlert
        open={verifyDialog1}
        onClose={handleCloseRequestDialog1}
        onConfirm={handleConfirmRequestDialog1}
        content={`Bulk verification completed successfully!`}
        confirmBtn='OK'
      />

      <Modal
        open={Boolean(openReportModal)} // Ensure modal only opens if a component is set
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
          top: "-9999px",
          left: "-9999px",
          zIndex: "-1",
        }}
      >
        <Box sx={ModalStyle}>
          {/* Conditionally render either Workreport or Unscheduleworkreport */}
          {openReportModal === "Workreport" && (
            <Workreport
              ref={printRef}
              data={data}
              serviceType={serviceType}
              rowData={selectedRowData}
            />
          )}
          {openReportModal === "Unscheduleworkreport" && (
            <Unscheduleworkreport
              ref={printRef}
              data={data}
              serviceType={serviceType}
              rowData={selectedRowData}
            />
          )}
        </Box>
      </Modal>

      <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center" style={{ marginTop: 16 }}>
        {(activeTab === 0 || activeTab === 1 || activeTab === 2 || activeTab === 9) && selectedRowIds.length > 0 && (
          <Button
            onClick={() => {
              //openDialog(); // Open dialog first
              confirmAuthorization(selectedRowIds, 1); // Then proceed with verification
            }}
            variant="contained"
            disabled={selectedRowIds.length === 0}
          >
            Bulk Verify
          </Button>
        )}
      </Stack>
    </Box>

  );
};

export default Userdash;